import useRoles from "customHooks/useRoles";
import React from "react";
import EmployeeRequests from "./EmployeeRequests";
import PeopleRequests from "./PeopleRequests";

function Requests() {
  const { roles } = useRoles();
  if (roles.people) return <PeopleRequests />;
  if (roles.employeeOrManager) return <EmployeeRequests />;
}

export default Requests;
